:host {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    width: 100%;
    padding: 8px;
    gap: 8px;
}

.row {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
    width: 100%;
    gap: 8px;

    & > .card {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: #202020;
        border-radius: 4px;
        padding: 4px;
        width: 100%;
        font-size: 12px;

        & > .header {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            color: #a0a0a0;
        }

        & > .value {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
        }
    }

    &.flags {
        flex-wrap: wrap;
        justify-content: space-between;

        & > div {
            opacity: 0.35;

            &.active {
                opacity: 1.0;
            }
        }
    }

    pre {
        width: 100%;
        max-height: 400px;
        overflow-x: hidden;
        overflow-y: scroll;
        font-size: 12px;
    }
}
